module.exports = __webpack_public_path__ + "media/images/illustrations/Icon-StarWorks-4de338d93f2279aabf5c198bb28981d1.svg";